import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { validateEmail } from "../../../utils/auth";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleEmailError: () => void;
  handleSubmit: (email: string, emailConfirmation: string) => void;
};

export const EmailEditForm: React.FC<Props> = ({
  handleEmailError,
  handleSubmit,
}) => {
  const schema = useMemo(() => {
    return z
      .object({
        email: z.string().min(1),
        emailConfirmation: z.string().min(1),
      })
      .refine((data) => data.email === data.emailConfirmation);
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{
        email: "",
        emailConfirmation: "",
      }}
      onSubmit={({ email, emailConfirmation }) => {
        if (!validateEmail(email)) return handleEmailError();

        handleSubmit(email, emailConfirmation);
      }}
    >
      <Message>
        新しいメールアドレスを入力していただき、｢変更｣ボタンをクリックしてください。
        <br />
        ご登録メールアドレスに、メールアドレス変更URLを送信いたします。
      </Message>
      <Message>※印は必須項目です。</Message>
      <ContentWrapper>
        <Input
          name="email"
          type="email"
          label="新しいメールアドレス"
          required
          dataWovnIgnore={true}
        />
      </ContentWrapper>
      <ContentWrapper>
        <Input
          name="emailConfirmation"
          type="email"
          label={`確認のため新しいメールアドレスを\n再入力してください`}
          required
          dataWovnIgnore={true}
        />
      </ContentWrapper>

      <ButtonWrapper>
        <Button type="submit" text="変更" btnStyle="primary" />
      </ButtonWrapper>
    </FormTemplate>
  );
};

const ContentWrapper = styled.div`
  margin: 0 0 20px;
  white-space: pre-line;
`;

const Message = styled.div`
  text-align: left;
  margin-bottom: 26px;
  font-size: 14px;
  font-weight: 300;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  button {
    font-family: "Hiragino Sans";
    font-weight: 500;
    line-height: 1em;
    height: auto;
  }
`;
